import React from 'react';
import PropTypes from 'prop-types';

class Product extends React.Component {
    static propTypes = {
        manufacturer : PropTypes.string.isRequired,
        details      : PropTypes.string.isRequired,
        dimensions   : PropTypes.string.isRequired,
        price        : PropTypes.string.isRequired,
        currency     : PropTypes.string.isRequired,
        imageUrl     : PropTypes.string.isRequired,
        productUrl   : PropTypes.string.isRequired,
        isHighlighted: PropTypes.func.isRequired,
    };

    /**
     * @param {*} props
     * @returns string}
     */
    getClassName(props) {
        const {isHighlighted} = this.props;

        if (isHighlighted()) {
            return 'suggestion-product suggestion-product--highlighted';
        }

        return 'suggestion-product';
    }

    /**
     * @returns {XML}
     */
    render() {
        const {
            manufacturer,
            details,
            dimensions,
            price,
            imageUrl,
            productUrl,
            currency,
        } = this.props;

        return (
            <a className={this.getClassName()} href={productUrl}>
                <div className="suggestion-product__image-container">
                    <img className="suggestion-product__image" src={imageUrl}/>
                </div>
                <div className="suggestion-product__overview">
                    <span className="suggestion-product__manufacturer">{manufacturer}</span>
                    <span>&nbsp;</span>
                    <span className="suggestion-product__details">{details}</span>
                    <span className="suggestion-product__dimensions">{dimensions}</span>
                </div>
                <div className="suggestion-product__price-container">
                    <span className="suggestion-product__currency">{currency}</span>
                    <span className="suggestion-product__price">{price}</span>
                </div>
            </a>
        );
    }
}

export default Product;
